import { render } from "./VideoLibView.vue?vue&type=template&id=2315a48e"
import script from "./VideoLibView.vue?vue&type=script&lang=js"
export * from "./VideoLibView.vue?vue&type=script&lang=js"

import "./VideoLibView.vue?vue&type=style&index=0&id=2315a48e&lang=scss"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__